import * as React from "react";
import ChipsCell from "components/common/ChipsCell";
import { TacticTechnique } from "security-app/components/SecurityEvents/Alerts/ColumnRenderers";
const TacticsTechniquesSummary = ({ eventDefinition }) => {
  var _a;
  const items = (_a = eventDefinition.tactics_techniques) != null ? _a : [];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, "Tactics/Techniques"), /* @__PURE__ */ React.createElement("dd", null, items.length ? /* @__PURE__ */ React.createElement(ChipsCell, { items, truncate: false, renderItem: (id) => /* @__PURE__ */ React.createElement(TacticTechnique, { value: id }) }) : /* @__PURE__ */ React.createElement("em", null, "No tactics/techniques")));
};
export default TacticsTechniquesSummary;
